import React from "react"
import { CardContainer, CardHeading } from "./CollapsibleFormCard"
import { Paragraph, ButtonLink, Label } from "buoy-core"
import { colors } from "buoy-theme"
import styled from "styled-components"
import { FormRow, InputContainer } from "./forms/common"
import PlanDetails from "../../common/components/PlanDetails"

const SettingsLabel = styled(Label)`
  margin: 0 6px 8px 0;
`

const SettingsCard = styled(CardContainer)`
  padding-bottom: 40px;
`

const SettingsCardHeading = styled(CardHeading)`
  margin-bottom: 40px;
`

const SettingsText = styled(Paragraph)`
  margin: 0;
`

const DeleteAccountLink = styled(ButtonLink)`
  color: #ff7156;
  display: block;
  margin: -16px auto 0;

  &:hover {
    color: #ff7156;
    cursor: pointer;
  }
`

const MaskContainer = styled.div`
  width: 100%;
  display: flex;
  margin: 4px 0;
`

const Dot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 4px;
  background-color: ${colors.neutral}
`

const PasswordMask = () => (
  <MaskContainer>
    {[...Array(8)].map((e, i) => <Dot key={i} />)}
  </MaskContainer>
)

const AccountSettingsCard = ({ email, showDeletionModal, planInformation, brand }) => (
  <React.Fragment>
    <SettingsCard margin="0 0 24px 0">
      <SettingsCardHeading>Account Settings</SettingsCardHeading>
      <FormRow>
        <InputContainer>
          <SettingsLabel>Email Address</SettingsLabel>
          <SettingsText>{email}</SettingsText>
        </InputContainer>
      </FormRow>
      <FormRow last>
        <InputContainer>
          <SettingsLabel>Password</SettingsLabel>
          <PasswordMask />
        </InputContainer>
      </FormRow>
    </SettingsCard>
    {planInformation && (
      <PlanDetails profile />
    )}
    <DeleteAccountLink onClick={showDeletionModal}>
      Delete account
    </DeleteAccountLink>
  </React.Fragment>
)

export { AccountSettingsCard as default }



// WEBPACK FOOTER //
// ./assets/account/components/AccountSettingsCard.js